import type { PrimaryFilterId } from '../../../filters/types/filters';
import { mapPositionsEntitiesToCompositionV3 } from '../../../filters/utils/role-skill-ent-kind';
import { ChartFallback } from '../../Chart/ChartFallback';
import { useChart } from '../../Chart/ChartProvider';
import type { CompositionMetricValues } from '../../PageConfigProvider/types/metric';
import { usePageState } from '../../PageState/PageStateProvider';
import { CompetitorDataProvider } from '../CompetitorDataProvider';
import type { DataProviderChildren, DataProviderSet } from '../types';
import { CompositionRawDataProvider } from './CompositionRawDataProvider';
import { convertCompositionDataV3 } from './composition-v3/convert-composition-data-v3';

type CompositionTopCompetitorsDataProviderProps = {
  primaryDimension: PrimaryFilterId;
  metric: CompositionMetricValues;
  exchangeRate?: number;
  children: DataProviderChildren<DataProviderSet | undefined>;
};

export const CompositionTopCompetitorsDataProvider = ({
  primaryDimension,
  metric,
  exchangeRate,
  children,
}: CompositionTopCompetitorsDataProviderProps) => {
  const { pageState } = usePageState();
  const { item } = useChart();
  const selectedEntity = pageState.primaryEntities?.[item?.id];

  return (
    <CompetitorDataProvider entityId={Number(selectedEntity?.id)}>
      {({ data: entities, status }) => (
        <ChartFallback status={status}>
          <CompositionRawDataProvider
            primaryDimension={primaryDimension}
            entitiesOverride={mapPositionsEntitiesToCompositionV3(entities)}
          >
            {({ data, status, monthRefs = [] }) =>
              children({
                data: data?.composition_v3
                  ? convertCompositionDataV3({
                      metric,
                      data: data.composition_v3,
                      segment: 'competitors',
                      exchangeRate,
                      monthRefs,
                    })
                  : undefined,
                status,
              })
            }
          </CompositionRawDataProvider>
        </ChartFallback>
      )}
    </CompetitorDataProvider>
  );
};
